import BusinessCharacteristicModel from '../../generated/types/model/resource/BusinessCharacteristicModel';

export default class BusinessCharacteristicViewModel extends BusinessCharacteristicModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
